export default __webpack_public_path__ + "static/media/BI2.18e8507d.svg";